import { combineReducers } from '@reduxjs/toolkit'
import { reducer as appointmentReducer } from 'src/slices/appointment'
import { reducer as shiftReducer } from 'src/slices/shift'
import { reducer as formReducer } from 'redux-form'
import { reducer as notificationReducer } from 'src/slices/notification'
import { reducer as courseReducer } from 'src/slices/course'
import { reducer as employeeReducer } from 'src/slices/employee'
import { reducer as paymentReducer } from 'src/slices/payment'
import { reducer as expenseReducer } from 'src/slices/expense'
import { reducer as graphReducer } from 'src/slices/graph'
import { reducer as incomeReducer } from 'src/slices/income'
import { reducer as orderReducer } from 'src/slices/order'
import { reducer as customerReducer } from 'src/slices/customer'
import { reducer as categoryReducer } from 'src/slices/category'
import { reducer as productReducer } from 'src/slices/product'
import { reducer as accountManagementReducer } from 'src/slices/accountManagement'
import { reducer as packageReducer } from 'src/slices/package'
import { reducer as purchasesRecordReducer } from 'src/slices/purchasesRecord'
import { reducer as stockReducer } from 'src/slices/stock'
import { reducer as inventoryRecordReducer } from 'src/slices/inventoryRecord'
import { reducer as salaryReducer } from 'src/slices/salary'
import { reducer as commissionReducer } from 'src/slices/commission'
import { reducer as roomReducer } from 'src/slices/room'
import { reducer as roleReducer } from 'src/slices/role'
import { reducer as storeReducer } from 'src/slices/store'
import { reducer as menuReducer } from 'src/slices/menu'
import { reducer as smsSetReducer } from 'src/slices/smsSet'
import { reducer as dictReducer } from 'src/slices/dict'

const rootReducer = combineReducers({
  appointment: appointmentReducer,
  course: courseReducer,
  customer: customerReducer,
  employee: employeeReducer,
  form: formReducer,
  notifications: notificationReducer,
  payment: paymentReducer,
  shift: shiftReducer,
  expense: expenseReducer,
  graph: graphReducer,
  income: incomeReducer,
  order: orderReducer,
  category: categoryReducer,
  product: productReducer,
  accountManagement: accountManagementReducer,
  package: packageReducer,
  purchasesRecord: purchasesRecordReducer,
  stock: stockReducer,
  inventoryRecord: inventoryRecordReducer,
  salary: salaryReducer,
  commission: commissionReducer,
  room: roomReducer,
  role: roleReducer,
  store: storeReducer,
  menu: menuReducer,
  smsSet: smsSetReducer,
  dict: dictReducer,
})

export default rootReducer
